import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

// Eski Android uygulamasından (Java, Google Play) web'e geçen oyuncu: OneSignal duyurusu
// `/?kaynak=android-uygulama` açar. Karşılama 7 gün ya da kapatılana / tamamlanana dek görünür;
// açıkken genel "ana ekrana ekle" şeridi ve bildirim hatırlatması susar (tek öneri).
export const ANDROID_WELCOME_SOURCE = 'android-uygulama';
const STARTED_KEY = 'tenis.androidWelcomeAt';
const CLOSED_KEY = 'tenis.androidWelcomeClosed';
const CHANGE_EVENT = 'tenis:android-welcome';
const WELCOME_MS = 7 * 24 * 3600 * 1000;

const read = (): boolean => {
  try {
    if (window.localStorage.getItem(CLOSED_KEY)) return false;
    const at = Number(window.localStorage.getItem(STARTED_KEY));
    return at > 0 && Date.now() - at < WELCOME_MS;
  } catch {
    return false;
  }
};

export function useAndroidWelcome() {
  const router = useRouter();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const sync = () => setActive(read());
    if (router.query.kaynak === ANDROID_WELCOME_SOURCE) {
      try {
        if (!window.localStorage.getItem(CLOSED_KEY)) {
          window.localStorage.setItem(STARTED_KEY, String(Date.now()));
        }
      } catch {
        // Depolama kapalıysa karşılama görünmez; site normal çalışır.
      }
    }
    sync();
    window.addEventListener(CHANGE_EVENT, sync);
    return () => window.removeEventListener(CHANGE_EVENT, sync);
  }, [router.query.kaynak]);

  const close = useCallback(() => {
    try {
      window.localStorage.setItem(CLOSED_KEY, String(Date.now()));
    } catch {
      // Yalnız bu açılışta kapanır.
    }
    setActive(false);
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }, []);

  return { active, close };
}
